// Global Instructions Rule Applied!
// Shape of GET /fund-transactions/fund/:fundId/closing-candidates
// (view__fund_closing_candidates): the Commitments checklist of a Closing
// fund transaction - one row per live standalone commitment of the fund with
// its selection state for the transaction being edited.
import { z } from 'zod'
import { validateWithZodSchema } from '../../core/utils/utilities.ts'

export const FundClosingCandidateRowSchema = z
  .object({
    fund_commitments__id: z.string(),
    investors__id: z.string().nullish(),
    investors__name: z.string().nullish(),
    accounts__id: z.string().nullish(),
    accounts__name: z.string().nullish(),
    fund_commitments__amount: z.number().nullish(),
    fund_commitments__amount_fmt: z.string().nullish(),
    fund_commitment_statuses__id: z.number().nullish(),
    fund_commitment_statuses__label: z.string().nullish(),
    // YYYY-MM-DD text (the columns are timestamptz written as ::date)
    fund_commitments__date_committed: z.string().nullish(),
    fund_commitments__date_closed: z.string().nullish(),
    // linked to the transaction being read (live link)
    prog__selected: z.boolean(),
    // the link's stamped amount once the closing is Booked
    prog__amount_at_close: z.number().nullish(),
    // already Closed WITH a date by something else: greyed, unselectable. A
    // legacy Closed row with NO date is a normal (unticked) candidate.
    prog__closed_elsewhere: z.boolean(),
    prog__closed_by_label: z.string().nullish()
  })
  .strict()

export const FundClosingCandidatesSchema = z
  .object({
    fund: z
      .object({
        funds__id: z.string().nullish(),
        funds__name: z.string().nullish(),
        currencies__symbol: z.string().nullish()
      })
      .passthrough(),
    rows: z.array(FundClosingCandidateRowSchema)
  })
  .strict()

export type FundClosingCandidateRow = z.infer<typeof FundClosingCandidateRowSchema>
export type FundClosingCandidates = z.infer<typeof FundClosingCandidatesSchema>

export const validateFundClosingCandidates = (data: unknown): FundClosingCandidates =>
  validateWithZodSchema(FundClosingCandidatesSchema, data, 'fund closing candidates')
